import { nsElements } from './config';
import { elementEventListener } from './utils/elementEventListener';
import { setAttributeToElement } from './utils/setAttributeToElement';
import { addElementToDOM } from './utils/addElementToDOM';
import { dispatchDidMount } from './utils/dispatch.didMount';
const doc = document;
export const vNodeMount = ({ vNode, container, oldEl, prevEl, nextEl }) => {
    switch (vNode.type) {
        case 'STRING':
            vNode._el = doc.createTextNode(vNode.text);
            break;
        case 'HTML':
            if (vNode.html.startsWith('<svg')) {
                const tempDiv = doc.createElement('div');
                tempDiv.innerHTML = vNode.html;
                vNode._el = tempDiv.firstElementChild;
            }
            else {
                vNode._el = doc.createElement('div');
                vNode._el.innerHTML = vNode.html;
            }
            break;
        default: {
            const isNS = nsElements.includes(vNode.tag);
            const el = vNode._el = isNS
                ? doc.createElementNS('http://www.w3.org/2000/svg', vNode.tag)
                : doc.createElement(vNode.tag);
            vNode.propsArray.forEach(({ key, value }) => {
                setAttributeToElement(el, vNode.tag, key, value);
            });
            vNode.hiddenPropsArray.forEach(({ key, value }) => {
                el[key] = value;
            });
            vNode.eventsArray.forEach(({ key, event }) => {
                el[key] = event;
                el.addEventListener(key, elementEventListener);
            });
            vNode.children.forEach(child => { vNodeMount({ vNode: child, container: el }); });
        }
    }
    vNode._el._vNode = vNode;
    addElementToDOM({ vNode, oldEl, prevEl, nextEl, container });
    vNode._el.isConnected &&
        dispatchDidMount(vNode);
};
